













































































































































import ReviewListPaginated from '@/components/ReviewListPaginated'
import DropDown from '@/components/DropDown'
import DropDownSearch from '@/components/DropDownSearch.vue'
import PourcentageStatTag from '@/components/PourcentageStatTag.vue'
import StatsTeam from '@/components/StatsTeam.vue'
import gql from '@/gqlService.coffee'
import utils from '@/utils.coffee'
import queries from "@/gql/queries.coffee"
import 'bulma-switch';
import settings from '@/settings.coffee'


export default {
    "name": 'ReviewListFilterTeam',
    "components":{ReviewListPaginated, DropDown, DropDownSearch, StatsTeam, PourcentageStatTag}
    "props": {}
    "computed":
        "is_production": ()->
            return settings.backendUrl == "https://hermes.mhr.re"
        "style": ()->
            return {
                height: this.height
            }
        "pourcentageStatTagValue": ()->
            ret = 0
            if @$store.state.stats
                sum = @$store.state.stats.reduce((acc, current)->
                    acc.total += current['from_this_morning_count']
                    acc.total -= current['from_this_morning_impossible']
                    acc.validated += current['from_this_morning_validated_count']
                    return acc
                ,{total:0, validated:0})
                if sum.total != 0
                    ret = Math.round(100 * sum.validated / sum.total)
            return ret
        "filters": ()->
            return {
                status:
                    this.status
                sentiment:
                    this.sentiment
                classified:
                    this.classified 
                late:
                    this.late
                platform:
                    this.platform
                establishment:
                    this.establishment
                consultant:
                    this.consultant
                search_string:
                    this.search_string
                dateBeginFilter:
                    this.dateBegin
                dateEndFilter:
                    this.dateEnd
                tag:
                    this.tag
                has_game_filter:
                    this.has_game_filter
            }
    "data": ()->
        return {
            "dateBegin": null
            "dateEnd": null
            "has_game_filter": false
            "status_set": null
            "tag": {name:null}
            "tag_set": [
                    {name: 'Supprimé', code: 'deleted'},
                    {name: 'Répondu', code: 'answered'},
                    {name: 'Impossible', code: 'Impossible'}
            ]
            "status": {"name": null, "uid": null}
            "sentiments": [
                {"name": "Positif", "value": true},
                {"name": "Négatif", "value": false}
            ]
            "sentiment": {"name": null, "value": null}
            "classified": false
            "height": (window.innerHeight-30)+ "px"
            "listHeight": (window.innerHeight-260)+ "px"
            "late":false
            "search_string": ""
            "platform": {"name": null}
            "platforms": gql.query({
                "model": "platform_set"
                "fields": "uid name"
            })
            "establishment": {"name": null}
            "establishments": null
            "consultant": {"lastname": null}
            "consultants": gql.query({
                "model": "consultant_set"
                "fields": "uid lastname firstname fullname"
            })
        }
    "methods":
        "tagClicked": (item)->
            # --
            @tag = item or {name: null}
        "dateBeginClicked": (item)->
            # --
        "dateEndClicked": (item)->
            # --
        "sentimentClicked": (item)->
            @sentiment = item or {"name": null, "value": null}
        "platformClicked": (item)->
            @platform = item or {"name": null}
        "establishmentClicked": (item)->
            @establishment = item or {"name": null}
        "consultantClicked": (item)->
            @consultant = item or {"lastname": null}
        "stateClicked": (item)->
            @status = item or {"name": null, "value": null}
            @classified = (@status.value == "Classified")
        "setHeight": utils.debounce(
            ()->
                @height = (window.innerHeight-30)+ "px"
                @listHeight = (window.innerHeight-260)+ "px" 
                return
            , 500)

        "updateSearchString": (newSearchString)->
            this.search_string = newSearchString
        "previousEstablishment": ()-> 
            currentIndex = @establishments.indexOf(@establishment)
            if currentIndex > 0 
                @establishment = @establishments[currentIndex - 1]
            else 
                @establishment = @establishments[@establishments.length - 1]
         "nextEstablishment": ()->
            currentIndex = @establishments.indexOf(@establishment)
            if currentIndex < @establishments.length - 1
                @establishment = @establishments[currentIndex + 1]
            else
                @establishment = @establishments[0]
    "mounted": ()->
        vm = this
        vm.setHeight()
        window.addEventListener('resize', this.setHeight)
        data = await queries.run("named_state_set")
        vm.status_set = data.body.data.named_state_set
        @establishments = await gql.query({
                "model": "establishment_set"
                "fields": "uid name"
                "filters": "active: true"
            })

        @$djangows['onmodelsignals']({"modelName": "review", "appLabel": "review"}, (event)->
            response = await queries.run('get_consultants_stats_from_view', [])
            vm.$store.commit(
                'set_stats',
                response.body.data.get_consultants_stats_from_view)
        )       
    "beforeDestroy": ()->
        window.addEventListener('resize', this.setHeight)
            

}
